import React, { memo } from 'react'
import { format } from 'date-fns'

import Tooltip from '../../../../../../../../components/Tooltip'

const TimelineSegment = memo(({ segment, index, name, totalDays, classes }) => {
  const widthPercentage = (segment.dates.length / totalDays) * 100
  const startDate = segment.dates[0]
  const endDate = segment.dates[segment.dates.length - 1]

  return (
    <div key={index} style={{ flex: `0 0 ${widthPercentage}%` }}>
      <Tooltip
        triggerElement={
          <div
            className={`${classes.segmentWrapper} ${segment.type === 'available' ? classes.available : classes.unavailable}`}
          />
        }
        placement="top"
      >
        <div>
          <div>{name}</div>
          <div>
            {format(startDate, 'MMM dd')} - {format(endDate, 'MMM dd, yyyy')}
          </div>
          <div>Status: {segment.type === 'available' ? 'Available' : 'Unavailable'}</div>
        </div>
      </Tooltip>
    </div>
  )
})

// Set displayName for better debugging in React DevTools
TimelineSegment.displayName = 'TimelineSegment'

export default TimelineSegment
